import { Tabs, Tab } from "@mui/material";
import { useRouter } from "next/router";
import * as T from "common/src/bindings/Translation2";

export default function DropTablesNav({ route }: { route: string }) {
  const router = useRouter();
  return (
    <div className="px-3 pt-2 pb-0 mb-3 sticky top-[48px] md:top-[92px] bg-bg0 z-20">
      <Tabs
        value={route}
        variant="scrollable"
        onChange={(_, t) => {
          switch (t) {
            case "Augments":
              router.push("/info/set-12/tables/augments");
              break;
            case "Reroll":
              router.push("/info/set-12/tables/reroll");
              break;
            case "Fortune":
              router.push("/info/set-12/tables/fortune");
              break;
            case "Encounters":
              router.push("/info/set-12/tables/encounters");
              break;
            case "Exalted":
              router.push("/info/set-12/tables/exalted");
              break;
            case "Double Up":
              router.push("/info/set-12/tables/double-up");
              break;
            case "Golden Egg":
              router.push("/info/set-12/tables/golden-egg");
              break;
            case "Lucky Gloves":
              router.push("/info/set-12/tables/lucky-gloves");
              break;
            case "Thief's Gloves":
              router.push("/info/set-12/tables/thiefs-gloves");
              break;
            case "Loot Subscription":
              router.push("/info/set-12/tables/loot-subscription");
              break;
            case "Call to Chaos":
              router.push("/info/set-12/tables/call-to-chaos");
              break;
            case "Golden Quest":
              router.push("/info/set-12/tables/golden-quest");
              break;
            case "Upgraded Journey":
              router.push("/info/set-12/tables/upgraded-journey");
              break;
            case "Sugarcraft":
              router.push("/info/set-12/tables/sugarcraft");
              break;
            case "Wish":
              router.push("/info/set-12/tables/wish");
              break;
          }
        }}
      >
        <Tab label={T.augments("GoldenQuest")} value="Golden Quest" />
        <Tab label={T.augments("AnUpgradedJourney")} value="Upgraded Journey" />
        <Tab label={T.traits("TFT11_Fortune")} value="Fortune" />
        <Tab label={T.traits("TFT12_Sugarcraft")} value="Sugarcraft" />
        <Tab label={T.common("Wish")} value="Wish" />
        <Tab label={T.common("Augments")} value="Augments" />
        <Tab label={T.common("Reroll")} value="Reroll" />
        <Tab label={T.augments("11Calltochaos")} value="Call to Chaos" />
        <Tab label={T.common("Double Up")} value="Double Up" />
        <Tab label={T.common("Golden Egg")} value="Golden Egg" />
        <Tab
          label={T.common("TFT_Portals_Unique_LootSubscription")}
          value="Loot Subscription"
        />
        <Tab label={T.items("ThiefsGloves")} value="Thief's Gloves" />
      </Tabs>
    </div>
  );
}
